import CardWrapper from "components/Common/CardWrapper";
import PageHeader from "components/Forex/Common/PageHeader";
import { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Disclamer from "./Disclamer";
// import Trader from "./Trader";
import { default as WTrader } from "./WebTrader";

function WebTrader() {
  const [accept, setAccept] = useState(localStorage.getItem("acceptTraderDisclamer"));
  const checkDisclamerAccepted = localStorage.getItem("acceptTraderDisclamer");
  useEffect(() => {
    document.title = "Web Trader";
  }, []);
  return ( <>
    <WTrader/>
  </> );
}

export default WebTrader;